<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>

    <v-spacer></v-spacer>

    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-card>
      <v-row class="search_area">
        <v-card-title></v-card-title>
        <v-col cols="12" sm="6" md="2">
          <template>
            <v-autocomplete
                :items="doctors"
                color="white"
                item-text="dr_name"
                item-key="id"
                item-value="id"
                label="Doctor List"
                v-model="searchParam.doctor"
                cols="3"
                sm="6"
                :loading="loadingstatus"
                outlined
                dense
                hide-details
                deletable-chips
                chips
            ></v-autocomplete>
          </template>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="date"
                  label="Select Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
              ></v-text-field>
            </template>

            <v-date-picker v-model="date" range></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="2">
          <template>
            <v-autocomplete
                :items="users"
                color="white"
                item-text="full_name"
                item-value="id"
                item-key="id"
                label="Counselor Name"
                v-model="searchParam.user_id"
                cols="3"
                sm="6"
                :loading="loadingstatus"
                outlined
                dense
                hide-details
                deletable-chips
                chips
            ></v-autocomplete>
          </template>
        </v-col>
        <v-col md="2">
          <v-autocomplete
              v-model="searchParam.operation_id"
              :items="operations"
              item-text="name"
              item-value="id"
              required
              label="Operation name"
              outlined
              dense
              deletable-chips
              chips
          ></v-autocomplete>
        </v-col>
        <v-col md="1">
          <template>
            <v-autocomplete
                :items="statusList"
                color="white"
                label="Status"
                v-model="searchParam.status"
                :loading="loadingstatus"
                outlined
                dense
                hide-details
                deletable-chips
                chips
            ></v-autocomplete>
          </template>
        </v-col>
        <v-col md="1">
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              hide-details
              :loading="loadingstatus"
              outlined
              dense
          ></v-text-field>
        </v-col>
        <v-col md="">
          <v-btn depressed color="primary" v-on:click="getFollowupData"
          ><v-icon>mdi-magnify</v-icon></v-btn
          >
        </v-col>
        <v-col md="1">
          <v-btn depressed color="primary" v-on:click="printList"
          ><v-icon>mdi-printer</v-icon></v-btn
          >
        </v-col>
        <v-col md="2">
          <v-row justify="space-around">
            <span v-for="item in followup_summary" :key="item.id">
              <v-badge color="red" :content="item.count" overlap>
                <v-chip :color="getColor(item.status)" text-color="white">
                  {{ item.status.toUpperCase() }}</v-chip
                >
              </v-badge>
            </span>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <div id="print">
      <v-card-title>OT Counseling Patient: Followup</v-card-title>
      <v-data-table
          :headers="followUpHeaders"
          :items="followUpDesserts"
          class="elevation-1"
          :search="search"
          dense
          mobile-breakpoint="0"
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
          disable-pagination
          :hide-default-footer="true"
          :item-class="itemRowBackground"
      >
        <template v-slot:item.operation.name="{ item }">
          <span v-if="item.operation">{{ item.operation.name }}</span>
          <v-chip v-if="item.variant" class="ma-2" color="primary" outlined small>
            {{ item.variant }}
          </v-chip>
          <v-chip v-if="item.variant_1" class="ma-2" color="primary" outlined small>
            {{ item.variant_1 }}
          </v-chip>
        </template>
        <template v-slot:item.comments="{ item }">
          <span>{{ item.comments }}</span>

          <v-chip v-if="item.ot_amount" class="ma-2" color="error" outlined small>
            {{ item.ot_amount }}
          </v-chip>
          <v-chip v-if="item.followup_type" class="ma-2" color="primary" outlined small>
            {{ item.followup_type }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="patientDetailsView(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="info"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-eye </v-icon>
              </v-chip>
            </template>
            <span>Patient View Details</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="addNote(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="warning"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-book </v-icon>
              </v-chip>
            </template>
            <span>Add Note</span>
          </v-tooltip>
          <v-tooltip top v-if="item.user_id == login_user_id && item.status == 'Active'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="otDone(item, 'OT Done')"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="red"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-flash </v-icon>
              </v-chip>
            </template>
            <span>Mark as OT Done</span>
          </v-tooltip>
          <v-tooltip top v-if="item.user_id == login_user_id && item.status == 'Active'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="otDone(item, 'Reschedule')"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="orange"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-redo-variant </v-icon>
              </v-chip>
            </template>
            <span>Mark as Reschedule</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary">Reset</v-btn>
        </template>
      </v-data-table>
      <v-col cols="12" sm="6">
        <v-card-title>Summary</v-card-title>
        <v-simple-table dense>
          <tbody>
          <tr v-for="item in followup_summary" :key="item.id">
            <td>{{ item.status }}</td>
            <td>{{ item.count }}</td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </div>
    <template>
      <v-row justify="center">
        <v-dialog v-model="viewDialog" persistent max-width="1190">
          <v-card>
            <v-col cols="12" sm="6">
              <v-card-title class="text-h5"> Patient Counseling </v-card-title>
              <v-text-field
                  label="patient id"
                  v-model="history_patient_id"
                  outlined
                  dense
                  v-on:change="getPatientReports"
              >
              </v-text-field>
              <v-chip
                  v-if="history_patient_details"
                  label
                  class="ma-2"
                  small
                  color="success"
                  text-color="white"
              >
                {{ history_patient_details.patient_name }}
              </v-chip>
              <v-chip v-if="history_patient_details" label class="ma-2" small>
                {{ history_patient_details.patient_phone }}
              </v-chip>
              <v-chip v-if="history_patient_details" label class="ma-2" small>
                {{ history_patient_details.patient_dob }}
              </v-chip>
              <v-chip v-if="history_patient_details" label class="ma-2" small>
                {{ history_patient_details.patient_sex }}
              </v-chip>
            </v-col>
            <v-row>
              <v-col cols="8">
                <v-card-title>Patient Counseling History</v-card-title>
                <v-data-table
                    :headers="patientHistoryHeaders"
                    :items="patientHistoryDesserts"
                    class="elevation-1"
                    :search="search"
                    dense
                >
                  <template v-slot:item.created_at="{ item }">
                    <span>{{ item.created_at }}</span>
                  </template>
                  <template v-slot:item.operation_subhead="{ item }">
                    <span v-if="item.operation">{{ item.operation.name }}</span
                    ><br />
                    <v-chip
                        v-if="item.operation_subhead"
                        class="ma-2"
                        color="error"
                        outlined
                        small
                    >
                      {{ item.operation_subhead }}
                    </v-chip>
                    <v-chip
                        v-if="item.variant"
                        class="ma-2"
                        color="primary"
                        outlined
                        small
                    >
                      {{ item.variant }}
                    </v-chip>
                    <v-chip
                        v-if="item.variant_1"
                        class="ma-2"
                        color="primary"
                        outlined
                        small
                    >
                      {{ item.variant_1 }} </v-chip
                    ><br />
                    <v-chip class="ma-2" color="primary" outlined small>
                      {{ item.ot_amount }}
                    </v-chip>
                  </template>

                  <template v-slot:item.followup_type="{ item }">
                    {{ item.followup_type }}<br />

                    <v-chip class="ma-2" color="info" outlined small>
                      {{ item.status }}
                    </v-chip>
                  </template>
                  <template v-slot:item.doctors="{ item }">
                    <span v-if="item.doctor"> {{ item.doctor.dr_name }}<br /> </span>
                    <v-chip class="ma-2" color="info" outlined small>
                      {{ item.counselor.full_name }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-col>
              <v-col cols="4">
                <v-card-title>Injection Treatment History</v-card-title>
                <v-simple-table dense>
                  <thead>
                  <tr>
                    <th>Date</th>
                    <th>Eye</th>
                    <th>OT Name</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in treatment_data" :key="index">
                    <td>{{ item.opp_date }}</td>
                    <td>{{ item.eye_type }}</td>
                    <td>{{ item.operation.name }}</td>
                  </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed color="warning" text @click="viewDialog = false">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-row justify="center">
      <v-dialog v-model="addNotedialog" persistent max-width="590">
        <v-form @submit.prevent="formSubmit()" ref="form" lazy-validation>
          <v-card>
            <v-card-title class="text-h5"> Patient Counseling: Add Note </v-card-title>
            <v-simple-table dense>
              <template v-slot:default>
                <tbody v-if="reschedule">
                <tr>
                  <td>Patient ID</td>
                  <td>{{ reschedule.patient_id }}</td>
                </tr>
                <tr>
                  <td>Patient Name</td>
                  <td>{{ reschedule.patient_name }}</td>
                </tr>
                <tr>
                  <td>Patient Phone</td>
                  <td>{{ reschedule.patient_phone }}</td>
                </tr>

                <tr>
                  <td>Counselor Note</td>
                  <td>
                    <v-textarea
                        dense
                        outlined
                        v-model="reschedule.comments"
                        label="Note"
                        solo
                        hide-details
                    ></v-textarea>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed color="warning" text @click="addNotedialog = false">
                Cancel
              </v-btn>
              <v-btn depressed color="primary" text @click="formSubmit"> SAVE </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>
  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";
export default {
  data() {
    return {
      date: [
        new Date().toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10),
      ],
      // date: new Date().toISOString().substr(0, 10),
      treatment_data: [],
      dialog: false,
      newDialog: false,
      viewDialog: false,
      addNotedialog: false,
      login_user_id: localStorage.getItem("userId"),
      menu2: false,
      menu3: false,
      loadingstatus: true,
      returnUrl: atshq.defaults.headers.common.app_URL,
      search: "",
      doctors: [],
      operations: [],
      ot_rooms: [],
      statusList: ["Active", "OT Done"],
      users: [],
      searchParam: {
        doctor: null,
        counselor_id: null,
        status: null,
        user_id: null,
        operation_id: null,
      },
      followup_text: "Followup Date",
      followup_type: ["OT Confirm", "Later on"],
      reschedule: {
        rescheduledate: new Date().toISOString().substr(0, 10),
        related_id: null,
        comments: null,
        operation_subhead: null,
        followup_type: null,
        ot_amount: 0,
        ot_schedule: false,
        prescription_id: null,
        patient_id: null,
        patient_name: null,
        variant: null,
        variant_1: null,
        doctor_id: null,
        referral_doctor_id: null,
        iol: null,
        iol_power: null,
        ot_no: null,
        cabine: null,
      },
      headers: [
        { text: "Patient ID", value: "patient_id" },
        {
          text: "Patient Name",
          value: "patient_name",
        },
        {
          text: "Advice Name",
          value: "advice_name",
        },

        {
          text: "Note",
          value: "note",
        },

        { text: "Doctor", value: "dr_name" },
        { text: "Prescription Date", value: "prescription_date" },
        { text: "Action", value: "actions", sortable: false },
      ],
      desserts: [],
      followup_summary: [],
      followUpHeaders: [
        { text: "Patient ID", value: "patient_id" },
        {
          text: "Patient Name",
          value: "patient.patient_name",
        },
        {
          text: "Patient Phone",
          value: "patient.patient_phone",
        },

        {
          text: "Operation Name",
          value: "operation.name",
        },
        // { text: "Note", value: "comments" },

        // { text: "Date", value: "date" },
        { text: "Doctor", value: "doctor.dr_name" },
        { text: "Referral", value: "referral_doctor.dr_name" },
        { text: "Counselor", value: "counselor.last_name" },
        // { text: "Status", value: "status" },
        { text: "", value: "actions", sortable: false },
      ],
      followUpDesserts: [],
      history_patient_id: null,
      history_patient_details: null,

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "OT Counseling",
          disabled: false,
          href: "/prescription/list",
        },
        {
          text: "Counseling Data",
          disabled: true,
          href: "",
        },
      ],

      // counseling history?

      patientHistoryHeaders: [
        { text: "Date", value: "date" },
        {
          text: "Operation Info",
          value: "operation_subhead",
        },
        { text: "Type", value: "followup_type" },
        // { text: "Amount", value: "ot_amount" },
        { text: "Doctor/Counselor", value: "doctors" },
        { text: "Followup Date", value: "followup_date" },
        { text: "Note", value: "comments" },
      ],
      patientHistoryDesserts: [],
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.getDoctors();
    this.getFollowupData();
    this.getUsers();
    this.getOperations();
  },
  methods: {
    itemRowBackground: function (item) {
      let $result = "";
      if (item.status == "OT Done") {
        $result = "success";
      }
      return $result;
    },
    getUsers() {
      atshq
          .get("users/user")
          .then((response) => {
            this.users = response.data.data;
            this.loadingstatus = false;
          })
          .catch((e) => {
            // this.errors.push(e);
            console.log(e);
          });
    },
    formSubmit() {
      console.log(this.reschedule);
      // return false;
      atshq
          .post("ot-module/ot-counsiling", {
            data: this.reschedule,
            user_id: localStorage.getItem("userId"),
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            this.loadingstatus = false;
            this.dialog = false;
            this.newDialog = false;
            this.$noty.success(response.data.messages);
            // this.getReports();
            this.addNotedialog = false;
            this.getFollowupData();
          })
          .catch((e) => {
            // this.errors.push(e);
            console.log(e);
          });
    },
    typeChange() {
      if (this.reschedule.followup_type == "OT Confirm") {
        this.followup_text = "OT Schedule Date";
        this.reschedule.ot_schedule = true;
      } else {
        this.followup_text = "Followup Date";
        this.reschedule.ot_schedule = false;
      }
    },
    getPatientCounseling(item) {
      this.reschedule.patient_id = item.patient_id;
      this.reschedule.patient_name = item.patient_name;
      this.reschedule.patient_phone = item.patient_phone;
      this.reschedule.advice_name = item.advice_name;
      this.reschedule.related_id = item.related_id;
      this.reschedule.variant = item.variant;
      this.reschedule.variant_1 = item.variant_1;
      this.reschedule.doctor_id = item.doctor_id;
      this.reschedule.referral_doctor_id = item.referral_doctor_id;
      this.reschedule.dr_name = item.dr_name;
      this.reschedule.note = item.note;
      // this.reschedule = item;
      // console.log(this.reschedule.doctor_id);
      // console.log(item.doctor_id);
      // console.log(item);
      // this.reschedule.push(item);
      this.dialog = true;
    },
    otDone(item, status) {
      if (confirm("are you sure?"))
        atshq
            .post("patients/ot-cousiling-ot-done/" + item.id + "?status=" + status)
            .then((response) => {
              // JSON responses are automatically parsed.
              this.$noty.success(response.data.messages);
              this.loadingstatus = false;
              // this.desserts = response.data.data;
              this.getFollowupData();
            })
            .catch((e) => {
              this.errors.push(e);
            });
    },

    getFollowupData() {
      this.loadingstatus = true;

      if (this.date.length == 1) {
        this.$noty.error("Opps !! Please Select Date ranges.");
        return false;
      }

      atshq
          .get(
              "patients/ot-cousiling-followup-data?date=" +
              this.date +
              "&doctor=" +
              this.searchParam.doctor +
              "&status=" +
              this.searchParam.status +
              "&operation_id=" +
              this.searchParam.operation_id +
              "&user_id=" +
              this.searchParam.user_id
          )
          .then((response) => {
            this.loadingstatus = false;
            this.followUpDesserts = response.data.data;
            this.followup_summary = response.data.summary;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    getDoctors() {
      atshq
          .get("doctors")
          .then((response) => {
            this.doctors = response.data.data;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },

    getColor(status) {
      if (status == "void") return "red";
      else return "green";
    },
    _print(item) {
      window.open(
          this.returnUrl + "printdoc/treatment/" + item.patient_id + "/" + item.id
      );
    },

    getOTSchedule(item) {
      window.location.href =
          "/ot-module/schedule-create?patient_id=" +
          item.patient_id +
          "&counseling_id=" +
          item.id;
    },
    invoice_gen(item) {
      this.$router.push("/invoice-create/" + item.patient_id);
      // console.warn(item);
    },
    dateSelect() {
      this.loadingstatus = true;
      this.getFollowupData();
    },
    patientDetailsView(item) {
      this.viewDialog = true;
      this.history_patient_id = item.patient_id;
      this.getPatientReports();
    },
    getPatientReports() {
      atshq
          .get(
              "ot-module/ot-counsiling-history-patient?patient_id=" + this.history_patient_id
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            this.loadingstatus = false;
            this.patientHistoryDesserts = response.data.data;
            this.history_patient_details = response.data.patient_data;
            this.treatment_data = response.data.treatment_data;
          })
          .catch((e) => {
            this.errors.push(e);
          });
      this.getFollowupData();
    },

    addNote(item) {
      this.addNotedialog = true;
      this.reschedule.patient_id = item.patient_id;
      this.reschedule.patient_name = item.patient.patient_name;
      this.reschedule.patient_phone = item.patient.patient_phone;
      this.reschedule.counseling_id = null;
      this.reschedule.status = "Note";
      console.log(item);
      // this.getPatientReports();
    },
    getOperations() {
      atshq
          .get("/operations")
          .then((response) => {
            this.operations = response.data.data;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    printList() {
      var disp_setting = "toolbar=yes,location=no,";
      disp_setting += "directories=yes,menubar=yes,";
      disp_setting += "scrollbars=yes,width=650, height=600, left=100, top=25";
      var content_vlue = document.getElementById("print").innerHTML;
      var docprint = window.open("", "", disp_setting);
      docprint.document.open();
      docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write(
          '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
      );
      // docprint.document.write(
      //   "<head><title>" + this.doctor.dr_name + " || " + this.date + "</title>"
      // );
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write("font-family:verdana,Arial;color:#000;");

      docprint.document.write(
          "font-family:Verdana, Geneva, sans-serif; font-size:10px;}"
      );
      docprint.document.write(
          "table td, table th {border: 1px solid #ddd;padding: 0px; font-size:9px;}"
      );
      docprint.document.write(
          "table th, table th {padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: #4CAF50;color: white;}"
      );
      docprint.document.write("table {width: 100%;}");

      docprint.document.write("a{color:#000;text-decoration:none;} </style>");
      docprint.document.write('</head><body onLoad="self.print()"><center>');
      docprint.document.write(content_vlue);
      docprint.document.write("</center></body></html>");
      docprint.document.close();
      docprint.focus();
    },
  },
};
</script>
<style scoped>
.success {
  background-color: rgb(215, 215, 44);
}
.search_area {
  background: grey;
}
</style>
